import * as React from 'react';

import styles from './x-axis-label.module.css';

type XAxisLabelProps = {
    children?: any;
};

export class XAxisLabel extends React.Component<XAxisLabelProps> {
    render() {
        return <div className={styles['x-axis-label']}>{this.props.children}</div>;
    }
}
